import { axios } from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchTutorialGroups(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/tutorial_groups', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchTutorialGroup(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/v1/tutorial_groups/${params.id}`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchTutorial(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/v1/tutorials/${params.id}`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
